export default __webpack_public_path__ + "static/photog-ro-f097a968c39be59b1ac6950bdd9979b4.png";